import { render, staticRenderFns } from "./SeoContentTab.vue?vue&type=template&id=81ca9348&"
import script from "./SeoContentTab.vue?vue&type=script&lang=js&"
export * from "./SeoContentTab.vue?vue&type=script&lang=js&"
import style0 from "./SeoContentTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports